<div class="modal-backdrop">
  <div class="modal-dialog">
    <header class="modal-header">
      <%= I18n.confirmation.modals.recoverable_error.title %>
    </header>

    <div class="modal-body">
      <% recoverable_errors.forEach(function(error) { %>
        <%= renderPartial('appointment_booking/wizard/templates/step/confirmation/modals/recoverable_error/' + error, obj) %>
      <% }) %>

      <div class="modal-buttons-container">
        <span class="modal-button" data-appointment-booking-wizard-behaviour="complete"><%= I18n.confirmation.modals.recoverable_error.finish_booking %></span>
      </div>
    </div>
  </div>
</div>
